import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { profileKeys } from '@/features/settings/queries';
import { PartnerIntegrationPendingState } from '@/features/settings/partner-integration/PartnerIntegrationPendingState';
import { getProfile } from '@/lib/profile';
import { ACCESS } from '@/features/access/access';
import { requireRoleAccess } from '@/features/access/role-route-guard';

/**
 * `/partner-integration` — split out of the old `/settings?section=api-keys`
 * tab into its own Organisation-group sidebar entry, separate from `/api-keys`.
 * `PartnerIntegrationSection` itself moved unchanged (still owner-only,
 * self-gated); only its page shell (`PartnerIntegrationPage`) and this route
 * are new.
 */
export const partnerIntegrationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/partner-integration',
  beforeLoad: requireRoleAccess(ACCESS.partner),
  loader: async ({ context: { queryClient } }) => {
    await queryClient
      .ensureQueryData({ queryKey: profileKeys.current(), queryFn: getProfile })
      .catch(() => undefined);
  },
  pendingComponent: PartnerIntegrationPendingState,
  pendingMs: 0,
  pendingMinMs: 0,
  component: lazyRouteComponent(
    () => import('@/features/settings/partner-integration/PartnerIntegrationPage'),
    'PartnerIntegrationPage',
  ),
});
